import { postForm, request } from './client'
import { USE_MOCK } from './config'
import { mockMonitorApi } from './mock'

export interface SolutionGroup {
  group_id: string
  group_name: string
  del_status: number
}

export interface Project {
  project_id: string
  project_name: string
  project_type: number
  project_description: string
  subject_word: string
  character_word: string
  event_word: string
  regional_word: string
  stop_word: string
  group_id: string
  user_id: string
  del_status: number
  source_platforms?: string[]
  monitor_duration?: number  // 监测时长（天），最长365
}

// Available source platforms for monitoring
export const SOURCE_PLATFORMS = [
  { id: 'weibo', name: '微博', name_en: 'Weibo' },
  { id: 'wechat', name: '微信', name_en: 'WeChat' },
  { id: 'news', name: '新闻网站', name_en: 'News Sites' },
  { id: 'app', name: '客户端', name_en: 'News Apps' },
  { id: 'video', name: '短视频', name_en: 'Short Video' },
  { id: 'forum', name: '论坛', name_en: 'Forums' },
  { id: 'zhihu', name: '知乎', name_en: 'Zhihu' },
  { id: 'xiaohongshu', name: '小红书', name_en: 'Xiaohongshu (RED)' },
  { id: 'bilibili', name: 'B站', name_en: 'Bilibili' },
  { id: 'douyin', name: '抖音', name_en: 'Douyin' },
  { id: 'kuaishou', name: '快手', name_en: 'Kuaishou' },
  { id: 'tieba', name: '贴吧', name_en: 'Tieba' },
]

export interface Article {
  article_public_id: string
  title: string
  content: string
  source_name: string
  publish_time: string
  emotionalIndex: number
  url: string
  [key: string]: any
}

export const monitorApi = USE_MOCK ? mockMonitorApi : {
  // Solution groups
  getGroupList: (page: number = 1) =>
    postForm('/monitor/list', { page }),

  addGroup: (group_name: string) =>
    postForm('/monitor/addgroup', { group_name }),

  updateGroup: (group_id: string, group_name: string) =>
    postForm('/monitor/updategroup', { group_id, group_name }),

  deleteGroup: (group_id: string) =>
    postForm('/monitor/deletegroup', { group_id }),

  // Projects
  getProjectList: (group_id: string, page: number = 1) =>
    postForm('/monitor/projectlist', { group_id, page }),

  getProjectInfo: (project_id: string) =>
    postForm('/monitor/projectinfo', { project_id }),

  addProject: (data: Partial<Project>) =>
    postForm('/monitor/addproject', data as any),

  updateProject: (data: Partial<Project>) =>
    postForm('/monitor/updateproject', data as any),

  deleteProject: (project_id: string) =>
    postForm('/monitor/deleteproject', { project_id }),

  // Article data
  getDataList: (params: {
    projectid: string
    pagenum: number
    searchkeyword?: string
    time_period?: number
    emotion?: string
    classify?: string
    sort?: number
    matchs?: number
    precise?: number
    similar?: number
  }) =>
    postForm('/monitor/data', params),

  getArticleDetail: (article_public_id: string, projectid: string) =>
    postForm('/monitor/detail', { article_public_id, projectid }),

  dataSearch: (params: Record<string, any>) =>
    postForm('/monitor/dataSearch', params),

  exportData: (params: Record<string, any>) =>
    request('/monitor/export', { method: 'POST', data: params, responseType: 'blob' }),
}
